import styled from "styled-components";
import { Container } from "styles/common/container";
import { breakpoints } from "styles/constants/breakpoints";

export const WrapContainer = styled.section`
  background: #fffbe9;
`;
export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 20px 0;

  @media ${breakpoints.mobile} {
    height: auto;
    width: 100%;
    padding-top: 0;

    img {
      height: auto;
      width: 100%;
    }
  }
`;
export const WrapperContainer = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  @media ${breakpoints.mobile} {
    height: 100%;
    width: 100%;
    background-color: #1e5af6;
    box-shadow: 0px 0px 68px 0px #f49b2629;
    img {
      background-color: white;
      border-radius: 8px;
      height: auto;
      width: 100%;
      margin: 0px 10px;
    }
  }
`;

export const AboutCTA = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
  text-align: center;
  cursor: pointer;
  gap: 8px;
  height: 36px;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.colors.brand["500"]};
  color: ${({ theme }) => theme.colors.white};
  font-family: Poppins, sans-serif;
  font-weight: 700;
  border-radius: 6px;
  text-decoration: none;
  margin-bottom: 10px;
  @media ${breakpoints.mobile} {
    width: 60%;
  }
`;
export const CardWrapper = styled.div`
  margin: 20px;
  background-color: #fffbe9;
  align-items: center;
  display: flex;
  flex-direction: column;
`;
export const CardHeading = styled.div`
  background-color: #fff7c9;
  font-family: Poppins, sans-serif;
  font-weight: 700;
  line-height: 28px;
  width: 328px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 10px;
  border-radius: 8px 8px 0px 0px;
`;

export const CardContent = styled.div`
  background-color: white;
  width: 328px;
  padding: 15px 10px;
  border-radius: 0px 0px 8px 8px;
`;
